import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
type SectionWrapperProps = {
  children: React.ReactNode;
  className?: string;
  background?: 'white' | 'cream' | 'light-blue' | 'navy';
  id?: string;
};
const bgClasses = {
  white: 'bg-white',
  cream: 'bg-cream',
  'light-blue': 'bg-light-blue',
  navy: 'bg-navy text-white'
};
export function SectionWrapper({
  children,
  className = '',
  background = 'white',
  id
}: SectionWrapperProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} id={id} className={`py-16 md:py-24 px-4 ${bgClasses[background]} ${className}`} data-id="element-186">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 40
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-6xl mx-auto" data-id="element-187">
        {children}
      </motion.div>
    </section>;
}